import { withRouter } from 'react-router-dom'
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import React, { Fragment } from 'react';
import { Formik, Form, Field, ErrorMessage, FieldArray } from 'formik';
import estilos from '../Steps/StepsComponent.module.css'
import estilosTabs from '../Tabs/TabsInspeccionarComponent.module.css'
import { useEffect } from 'react';

function StepValidacionComponent(props) {

    const [guias, setGuias] = React.useState([]);

    const equipoCoccion = ['Uno', 'Dos', 'Tres', 'Cuatro', 'Cinco'];

    const handleNuevaGuia = () => {
        setGuias([...guias,
        {
            nombre: 'asd'
        }])
    }

    return (
        <Fragment>
            <Formik
                enableReinitialize={true}
                initialValues={{}}
                onSubmit={(valores) => {

                }}>
                {(props) => (
                    <Form>
                        <div className='row' style={{ textAlign: 'center !important', padding: '1%', paddingBottom: '1%', border: '1px solid black' }}>
                            <label className={`${estilos.labelUI} mb-2`}>Validación</label>
                            <div className='col-6'>
                                <br />
                                <div className="row">
                                    <div className="col">
                                        <label htmlFor='datosgenerales'>Datos Generales de la Producción</label>
                                    </div>
                                    <div className="col-6">
                                        <Field type="text" className="form-control form-control-sm" id="datosgenerales" name="datosgenerales" placeholder="Datos generales de la producción" required />
                                    </div>
                                </div>
                                <br />
                                <div className="row">
                                    <div className="col">
                                        <label htmlFor='nombretapada'>Nombre de la tapada</label>
                                    </div>
                                    <div className="col">
                                        <Field type="text" className="form-control form-control-sm" id="nombretapada" name="nombretapada" placeholder="Nombre de la tapada" required />
                                    </div>
                                </div>
                                <br />
                                <div className="row">
                                    <div className="col">
                                        <label htmlFor='especiemagueyvalidacion'>Especie de Maguey</label>
                                    </div>
                                    <div className="col">
                                        <Field
                                            component="select"
                                            id="especiemagueyvalidacion"
                                            name="especiemagueyvalidacion"
                                            className="form-select"
                                            multiple={false}
                                            required
                                        >
                                            <option defaultValue>Especie de Maguey</option>
                                            {equipoCoccion.map((t, index) => (
                                                <option key={index} value={t}>{t}</option>
                                            ))}
                                        </Field>
                                    </div>
                                </div>
                                <br />
                                <div className="row">
                                    <div className="col">
                                        <label htmlFor='kilogramosproduccion'>Kilogramos de Producción</label>
                                    </div>
                                    <div className="col">
                                        <Field type="number" className="form-control form-control-sm" id="kilogramosproduccion" name="kilogramosproduccion" placeholder="Kilogramos de producción" required />
                                    </div>
                                </div>
                            </div>
                            <div className='col-6'>
                                <br />
                                <div className="row">
                                    <div className="col">
                                        <label htmlFor='rendimientoreal'>Rendimiento Real</label>
                                    </div>
                                    <div className="col-6">
                                        <Field type="text" className="form-control form-control-sm" id="rendimientoreal" name="rendimientoreal" placeholder="Rendimiento Real" disabled required />
                                    </div>
                                </div>
                                <br />
                                <div className="row">
                                    <div className="col">
                                        <label htmlFor='rendimientoteorico'>Rendimiento Teorico</label>
                                    </div>
                                    <div className="col">
                                        <Field type="text" className="form-control form-control-sm" id="rendimientoteorico" name="rendimientoteorico" placeholder="Rendimiento Teorico" disabled required />
                                    </div>
                                </div>
                                <br />
                                <div className="row">
                                    <div className="col">
                                        <label htmlFor='eficiencia'>Eficiencia</label>
                                    </div>
                                    <div className="col">
                                        <Field type="text" className="form-control form-control-sm" id="eficiencia" name="eficiencia" placeholder="Eficiencia" disabled required />
                                    </div>
                                </div>
                                <br />
                                <div className="row">
                                    <div className="col">
                                        <label htmlFor='artvalidacion'>Porcentaje de ART</label>
                                    </div>
                                    <div className="col">
                                        <Field type="number" className="form-control form-control-sm" id="artvalidacion" name="artvalidacion" placeholder="Porcentaje de ART" required />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <br />
                        <div className='row'>
                            <div className="col">
                            </div>
                            <div className="col" style={{ textAlign: 'center !important', padding: '1%', paddingBottom: '1%', border: '1px solid black' }}>
                                <label className={`${estilos.labelUI} mb-2`}>Validación de Guias</label>
                                <div className='col'>
                                    <br />
                                    <div className="row">
                                        <FieldArray
                                            name='validacionguias'
                                            render={arrayHelpers => (
                                                <div>
                                                    {guias.map((g, index) => (
                                                        <div className="col-10" key={index}>
                                                            <Field type="text" className="form-control form-control-sm" id="datosgenerales" name="datosgenerales" placeholder="Datos generales de la producción" required />
                                                            <br />
                                                        </div>
                                                    ))}
                                                </div>
                                            )}
                                        />
                                        <div className="col">
                                            <div style={{ textAlign: "center" }}>
                                                <button type="button" className={`btn ${estilos.botonCircular}`} onClick={handleNuevaGuia}>+ </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Form>
                )}
            </Formik>
        </Fragment>
    )

}
export default withRouter(StepValidacionComponent)